import { BaseMapper } from '@/core/mapper';

import { OneTimePass } from '@/core/one-time-pass';
import { Worker } from '@/core/worker';
import { WorkerInduction } from '@/core/worker-induction';

const schema = {
  assessment_sections: {
    parseFrom: 'relationships.assessment_sections',
    omitFromRequest: true,
  },
  assessment_status: {
    parseFrom: 'meta.assessment_status',
    omitFromRequest: true,
  },
  current_status: {
    parseFrom: 'meta.current_status',
    omitFromRequest: true,
  },
  one_time_pass: {
    fromResponse: (entity) => {
      const oneTimePass = _.get(entity, 'relationships.one_time_pass');
      return oneTimePass && new OneTimePass(oneTimePass);
    },
    omitFromRequest: true,
  },
  uuid: {
    parseFrom: 'attributes.uuid',
  },
  worker: {
    fromResponse: (entity) => {
      const worker = _.get(entity, 'relationships.worker');
      return worker && new Worker(worker);
    },
    omitFromRequest: true,
  },
  worker_inductions: {
    parseFrom: 'relationships.worker_inductions',
    fromResponse: entity => _.get(entity, 'relationships.worker_inductions', [])
      .map(wi => new WorkerInduction(wi)),
    omitFromRequest: true,
  },
};

class WorkerOneTimePass extends BaseMapper {
  constructor(entity = null) {
    super({ entity, schema });
  }
}

WorkerOneTimePass.schema = schema;

export default WorkerOneTimePass;
